import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { isEmptyObject } from 'jquery';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';

import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Services from '../../services/service';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme, tableOptions } from '../../util/MuiTableTheme';
import { MODALACTION } from '../../config/constants';

const { CREATE, EDIT, DELETE } = MODALACTION;

class RoleAccess extends Component {
  constructor(props){
    super(props);
    this.state = {
      listRole: [],
      roleName: '',
      addModal: false,
      actionModal: '',
      selectedItem: {}
    };
  }

  componentDidMount(){
    this.getAllRole();
  }

  getAllRole = () => {
    Services.getAllRoleAccess()
      .then(res => {
        this.setState({
          listRole: res
        });
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      });
  };

  handleFieldChange = (key) => (e) => {
    const state = { [key]: e.target.value };
    this.setState(state);
  };

  handleAddRole = () => {
    const { actionModal, roleName } = this.state; 
    const payload = {
      roleName: roleName
    };

    Services.postAddRoleAccess(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', `${actionModal} Role successfull`, 'top-right');
        this.toggleAddModal();
        this.getAllRole();
      })
      .catch(err => {
        this.toggleAddModal();
        this.getAllRole();
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      })
  }

  handleUpdateRole = () => {
    const { actionModal, roleName, selectedItem } = this.state;
    const payload = {
      roleName: roleName === '' ? selectedItem.roleName : roleName
    };

    const param = { params: { 
      roleId: selectedItem._id
    }};

    Services.updateRoleAccess(payload, param)
      .then(res => {
        this.props.addNotification('success', 'Success', `${actionModal} Role successfull`, 'top-right');
        this.toggleAddModal();
        this.getAllRole();
      })
      .catch(err => {
        this.toggleAddModal();
        this.getAllRole();
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      })
  }

  handleDeleteRole = () => {
    const { selectedItem, actionModal } = this.state;
    const payload = { params: { 
      roleId: selectedItem._id
    }};

    Services.deleteRoleAccess(payload)
    .then(res => {
      this.props.addNotification('success', 'Success', `${actionModal} Role successfull`, 'top-right');
      this.toggleAddModal();
      this.getAllRole();
    })
    .catch(err => {
      this.toggleAddModal();
      this.getAllRole();
      this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
    })
  
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Role Management</li>
      </ol>
      <h1 className="page-header">Role Access Management </h1>
    </div>
  );

  renderRoleTable = () => {
    const { listRole } = this.state;

    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "roleName",
        label: "Role Name",
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: "createDate",
        label: "Date Created",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment(value).format('DD-MM-YYYY')
        }
      },
      {
        name: "updateDate",
        label: "Date Updated",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => moment(value).format('DD-MM-YYYY')
        }
      },
      {
        name: "Action",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px", maxWidth: "200px" }}),
          customBodyRender: (value, tableMeta) => {
            return (
              <div className="with-btn text-nowrap">
                <Link
                  to={{
                    pathname: '/setting/list-menu',
                    state: {
                      selectedItem: listRole[tableMeta.rowIndex]
                    }
                  }}
                >
                  <button className="btn btn-sm btn-lime width-90 m-r-2" onClick={() => {} }>EDIT MENU</button>
                </Link>
                <button 
                  className="btn btn-sm btn-primary width-60 m-r-2"
                  onClick={() => this.toggleAddModal(EDIT, listRole[tableMeta.rowIndex])}
                >{EDIT}</button>
                <button
                  onClick={() => this.toggleAddModal(DELETE, listRole[tableMeta.rowIndex])}
                  className="btn btn-sm btn-danger width-70 m-r-2">{DELETE}</button>
              </div>
            );
          }
        }
      }
    ];

    const options = {
      ...tableOptions,
      // filterType: 'dropdown',
      // responsive: 'scrolldown',
      // selectableRows: 'none',
      customToolbar: () => (
        <button onClick={() => this.toggleAddModal(CREATE)} className="btn btn-sm btn-primary width-70">Add</button>
      ),
    };
      
    return (
    <MuiThemeProvider theme={getMuiTheme()}>
      <MUIDataTable
        title={"List Role"}
        data={listRole}
        columns={columns}
        options={options}
      />
    </MuiThemeProvider>
    )
  };


  toggleAddModal = (action='', item={}) => {
    console.log('item', item);
    this.setState({ 
      addModal: !this.state.addModal,
      roleName: '',
      actionModal: action,
      selectedItem: item
    });
  };

  setHeaderItemText = (value) => {
    switch (value) {
      case CREATE :
        return 'Add Role';
      case EDIT :
        return 'Edit Role';
      case DELETE : 
        return 'Are you sure want to delete ?';
      default:
        return '';
    }
  }

  setActionButton = (value) => {
    switch (value) {
      case CREATE :
        this.handleAddRole();
        break;
      case EDIT :
        this.handleUpdateRole();
        break;
      case DELETE : 
        this.handleDeleteRole();
        break;
      default:
        break;
    }
  }

  renderAddModal = () => {
    const { addModal, roleName, selectedItem, actionModal } = this.state;
    const textHeader = this.setHeaderItemText(actionModal);
    const filled = isEmptyObject(selectedItem);
    const isEmpty = roleName === '';

    return (
      <Modal isOpen={addModal} toggle={() => this.toggleAddModal()}>
        <ModalHeader toggle={() => this.toggleAddModal()}>{textHeader}</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Role Name</label>
            <input 
              onChange={this.handleFieldChange('roleName')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem.roleName : roleName}
              disabled={actionModal === DELETE}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleAddModal()}>Cancel</button>
          <button className="btn btn-primary" disabled={isEmpty} onClick={() => this.setActionButton(actionModal)}>{actionModal}</button>
        </ModalFooter>
      </Modal>
    )
  }
  

  render() {
    return (
      <div>
        {this.renderBreadcrumb()}
        {this.renderRoleTable()}
        {this.renderAddModal()}
      </div>
    )
  }
}


export default withNotification(RoleAccess);
